import { Component, OnInit, Renderer, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { InformesService } from 'app/services/informes.service';
//Modales
import { ServiciosBeneficiarioComponent } from 'app/modals/apoyo-usuario/beneficiarios/servicios-beneficiario/servicios-beneficiario.component';
import { BitacoraComponent } from 'app/modals/apoyo-usuario/beneficiarios/bitacora/bitacora.component';
import { InfoContratoComponent } from 'app/modals/apoyo-usuario/beneficiarios/info-contrato/info-contrato.component';
import { BeneficiarioTelComponent } from 'app/modals/apoyo-usuario/beneficiarios/beneficiario-tel/beneficiario-tel.component';
import { BeneficiarioCelComponent } from 'app/modals/apoyo-usuario/beneficiarios/beneficiario-cel/beneficiario-cel.component';
import { NotasIngresoComponent } from 'app/modals/apoyo-usuario/beneficiarios/opciones/notas-ingreso/notas-ingreso.component';
import { NotasSeguimientoComponent } from 'app/modals/apoyo-usuario/beneficiarios/opciones/notas-seguimiento/notas-seguimiento.component';
import { InformacionComponent } from 'app/modals/apoyo-usuario/beneficiarios/opciones/informacion/informacion.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HistoriaClinicaComponent } from 'app/modals/historia-clinica/historia-clinica.component';
import { OpcionesModalService } from 'app/services/apoyo-usuarios/opciones-modal.service';
import { DatosOpcModal } from 'app/entities/datos-opc-modal';

@Component({
  selector: 'app-beneficiarios',
  templateUrl: './beneficiarios.component.html',
  styleUrls: ['./beneficiarios.component.scss']
})
export class BeneficiariosComponent implements OnInit, AfterViewInit, OnDestroy {

  private fechaFinal: string;
  private fechaInicial: string;
  public fecha_final: any = moment();
  public fecha_inicial:any = moment("2014-03-22");
  public spinner: boolean;


  //Data Table
  public dataTable_options;
  public tableOpt;
  @ViewChild(DataTableDirective, {static:true})
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>
  
  constructor(private _informe: InformesService, private _renderer:Renderer, private dialog: MatDialog, private _snackBar: MatSnackBar, private _opciones: OpcionesModalService) { 
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.tableOpt = [];
  }

  ngOnInit() {
    this.dataTable_options = {
      columns: [
        {
          title: ''
        },
        {
          title: 'Promedio Servicios',
          data: 'promeServAde'
        },
        {
          title: 'Total Servicios',
          render: (data, type, row, meta)=>{
            return `<a ts_doc="${row.bendoc}">${data}</a>`
          }
        },
        {
          title: 'Meses',
          data: 'PerTiempoBen'
        },
        {
          title: 'Documento',
          data: 'bendoc'
        },
        {
          title: 'Nombre Completo',
          render: (data, type, row, meta)=>{
            return `<a nom_doc="${row.bendoc}">${data}</a>`
          }
        },
        {
          title: 'Servicio Adecuado Total',
          data: 'servAdeTotal'
        },
        {
          title: 'Promedio Servicios Mensuales',
          data: 'psm'
        },
        {
          title: 'Radicado',
          data: 'grugru'
        },
        {
          title: 'Fecha Ingreso AP',
          data: 'ApoUsuDataini'
        },
        {
          title: 'Teléfono',
          data: 'bentel'
        },
        {
          title: 'Celular',
          data: 'bencel'
        },
        {
          title: 'Retiros',
          data: 'retiros'
        },
        {
          title: 'Edad',
          data: 'edad'
        },
        {
          title: 'Servicios Después de Ingreso AP',
          data: 'siap'
        },
        {
          title: 'N° Ingresos AP',
          data: 'inap'
        },
        {
          title: 'Prioridad Apoyo al Usuario',
          data: 'priap'
        }
      ]
    }
    this.spinner = false;
  }

  public buscarAUBeneficiarios(){
    this.spinner = true;

    this.fechaInicial = moment(this.fecha_inicial).get('year').toString()+"-"+(moment(this.fecha_inicial).get('month')+1).toString()+"-"+moment(this.fecha_inicial).get('date').toString();
    this.fechaFinal = moment(this.fecha_final).get('year').toString() +"-"+(moment(this.fecha_final).get('month')+1).toString() +"-"+ moment(this.fecha_final).get('date').toString();

    this._informe.ApoyoUsuariosBeneficiarios(this.fechaInicial, this.fechaFinal).subscribe((data:any) => {
      this.spinner = false;
      this.renderer();
      this.tableOpt = data.resultado;
    });
  }

  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
    this._renderer.listenGlobal('document', 'click', (e) => {
      e.stopPropagation();
      let modal;

      if(e.target.hasAttribute('ts_doc')){
        modal = this.dialog.open(ServiciosBeneficiarioComponent,{
          height: '90%',
          width: '90%',
          data: {
            beneficiario_doc: e.target.getAttribute('ts_doc')
          }
        });
      }else if(e.target.hasAttribute('nom_doc')){
        modal = this.dialog.open(BitacoraComponent, {
          data: {
            beneficiario_doc: e.target.getAttribute('nom_doc')
          }
        });
      }else if(e.target.hasAttribute('titular')){
        modal = this.dialog.open(InfoContratoComponent, {
          data: {
            fecha_inicio: this.fechaInicial,
            fecha_final: this.fechaFinal,
            id_titular: e.target.getAttribute('titular')
          }
        });
      }else if(e.target.hasAttribute('tel')){
        modal = this.dialog.open(BeneficiarioTelComponent, {
          data: {
            documento_benef: e.target.getAttribute('bendoc'),
            benef_telefono: e.target.getAttribute('tel'),
            indice: e.target.getAttribute('indice')
          }
        });
      }else if(e.target.hasAttribute('cel')){
        modal = this.dialog.open(BeneficiarioCelComponent, {
          data: {
            beneficiario_doc: e.target.getAttribute('bendoc'),
            celular: e.target.getAttribute('cel'),
            indice: e.target.getAttribute('indice')
          }
        });
      }else{
        return;
      }

      /* modal.afterClosed().subscribe((result:any) => {
        if(result.respuesta == true){
          console.log(this.tableOpt[result.indice].bentel);
          this.tableOpt[result.indice]['bentel'] = '3415217';
          this.tableOpt.push(...this.tableOpt)
          this.tableOpt = [...this.tableOpt];
          console.log(this.tableOpt[result.indice].bentel); 
          this.tableOpt[0].bentel = '4252626';
          this.tableOpt = [...this.tableOpt];
        } 
      });*/

    });
  }


  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }


  public opcionesModal(opc: string, objeto: DatosOpcModal){
    this._opciones.Modales(opc, objeto).subscribe((data:any)=> {
      console.log(data);
    });
  }
}

